import { defaultTimes } from 'app/config/config';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import CourseFormSchedule from '../forms/CourseFormSchedule';

const ConfigureCourse = ({
  t,
  config,
  changeTextButton,
  changeDisabledButton,
  changeTimetableToSave,
  courseTimetable,
  courseTimeUnitCurrent,
  timesUnit,
  enableAdvancedProgramming,
  course,
}) => {
  changeTextButton(t('actions:Finish'));
  const [timetable, setTimetable] = useState(courseTimetable);

  useEffect(() => {
    setTimetable(courseTimetable && courseTimetable.length > 0 ? courseTimetable : defaultTimes);
  }, [courseTimetable]);

  function checkErrorDays(time) {
    let error = false;
    for (let period of time) {
      if (!period.days || period.days.length === 0) {
        error = true;
        break;
      }
      for (let day of period.days) {
        if (day.error) {
          error = true;
          break;
        }
      }
    }
    return error;
  }

  function changeTimetable(time, appliedSameShechule) {
    let error = false;
    if (time && time.length > 0) {
      for (let period of time) {
        if (period.start_at && period.end_at) {
          if (new Date(period.start_at) > new Date(period.end_at)) {
            //period.error = true;
            //error = !error ? true : error;
            period.end_at = period.start_at;
          } else {
            period.error = false;
          }
        } else if (period.start_date && period.end_date) {
          if (new Date(period.start_date) > new Date(period.end_date)) {
            period.end_date = period.start_date;
            period.error = true;
            error = true;
          } else {
            period.error = false;
          }

          // Check for overlapping dates with previous periods
          const periodIndex = time.indexOf(period);
          if (periodIndex > 0) {
            const previousPeriod = time[periodIndex - 1];
            if (previousPeriod.end_date && period.start_date) {
              if (new Date(period.start_date) <= new Date(previousPeriod.end_date)) {
                period.error = true;
                error = true;
              }
            }
          }
        } else {
          error = error === false ? true : error;
        }
      }
    } else {
      error = true;
    }

    if (!error && !enableAdvancedProgramming) {
      error = checkErrorDays(time);
    }

    if (error) {
      console.log('error', error);
      changeDisabledButton(true);
    } else {
      changeTimetableToSave(time, appliedSameShechule);
      changeDisabledButton(false);
    }
    setTimetable(time);
  }

  return (
    <div className="new-course-step-schedule">
      <span className="new-course-step-schedule__title">{t('course:Configure course')}</span>
      <span className="new-course-step-schedule__subtitle">{t('Course content will be automatically distributed according to this schedule')}</span>
      <span className="new-course-step-schedule__form-container"></span>

      <div className="new-course-step-schedule__form-container">
        <div className="new-course-step-schedule__form">
          <CourseFormSchedule
            config={config}
            changeTimetable={changeTimetable}
            timetable={timetable}
            courseTimeUnitCurrent={courseTimeUnitCurrent}
            timesUnit={timesUnit}
            course={course}
            enableAdvancedProgramming={enableAdvancedProgramming}
          />
        </div>
      </div>
    </div>
  );
};

ConfigureCourse.propTypes = {
  end: PropTypes.bool,
  changeDisabledButton: PropTypes.func,
  changeTextButton: PropTypes.func,
  changeTimetableToSave: PropTypes.func,
  courseTimetable: PropTypes.array,
  courseTimeUnitCurrent: PropTypes.string,
  timesUnit: PropTypes.array,
  enableAdvancedProgramming: PropTypes.bool,
  course: PropTypes.object,
  t: PropTypes.func,
  config: PropTypes.object,
};

ConfigureCourse.defaultProps = {
  end: false,
  changeDisabledButton: function () {},
  changeTextButton: function () {},
  changeTimetableToSave: function () {},
  enableAdvancedProgramming: false,
  course: {},
  t: function () {},
  config: {},
};

export default withTranslation(['new-course', 'course'])(ConfigureCourse);
